import React, { useContext, useEffect, useRef, useState } from 'react';
import { useForm } from 'react-hook-form';

import AuthContext from 'router/AuthContext';

import AppBar from '@mui/material/AppBar';
import Button from '@mui/material/Button';
import CssBaseline from '@mui/material/CssBaseline';
import TextField from '@mui/material/TextField';
import Link from '@mui/material/Link';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import Container from '@mui/material/Container';
import Toolbar from '@mui/material/Toolbar';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import PgmList from './PgmList';
import logo from 'assets/img/dohwa.png';
import trialQr from 'assets/img/trial_qr.png';
import manualPdf from 'assets/manual/20260323_도화 앱스 사용 메뉴얼.pdf';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import BoardList from './board/List';
import BoardDetail from './board/Detail';
import BoardRegister from './board/Register';

function Copyright(props) {
  return (
    <Typography variant="body2" color="text.secondary" align="center" {...props}>
      {'Copyright © '}
      <Link color="inherit" href="https://www.dohwa.co.kr/">
        DOHWA ENGINEERING
      </Link>{' '}
      {new Date().getFullYear()}
      {'.'}
    </Typography>
  );
}

const theme = createTheme({
  palette: {
    primary: { main: '#004442' }
  }
});

export default function LogIn() {
  const navigate = useNavigate();
  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitted }
  } = useForm({
    mode: 'all',
    defaultValues: {
      id: '',
      password: ''
    }
  });

  const isTrialValid = new Date() <= new Date('2026-04-18T00:00:00');

  let auth = useContext(AuthContext);

  let userPwInput = useRef(null);

  const [error, setError] = useState(false);

  const [openFindId, setOpenFindId] = useState(false);
  const [openResetPassword, setOpenResetPassword] = useState(false);
  /*const [id, setId] = useState('');
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');*/

  const [id, setId] = useState('');
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [findId, setFindId] = useState(null);
  const [openManual, setOpenManual] = useState(false);
  // qna modal 뷰 상태 머신: view = 'list' | 'detail' | 'register' | 'modify' | 'reply'
  const [qna, setQna] = useState({ open: false, view: 'list', viewState: null });

  const handleOpenQna = () => setQna({ open: true, view: 'list', viewState: null });
  const handleCloseQna = () => setQna({ open: false, view: 'list', viewState: null });

  const qnaColumns = [
    { id: 'row_number', label: 'No', minWidth: 50, align: 'center' },
    { id: 'subject', label: '제목', minWidth: 200, align: 'left', subjectAlign: 'left' },
    { id: 'created_id', label: '작성자', minWidth: 80, align: 'center' },
    { id: 'author_company', label: '소속', minWidth: 100, align: 'center' },
    { id: 'created_at', label: '작성일', minWidth: 120, align: 'center' }
  ];

  const signIn = (data) => {
    const userId = data.id;
    const password = data.password;
    auth.signin({ userId, password }, (result) => {
      if (result?.status === 401) {
        userPwInput.current.focus();
        setError(true);
      }
    });
  };

  const onSubmit = async (data) => {
    await signIn(data);
  };

  const handleJoin = () => {
    navigate('/join');
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      signIn();
    }
  };

  const handleOpenFindId = () => {
    setOpenFindId(true);
  };
  const handleCloseFindId = () => {
    setOpenFindId(false);
  };

  const handleOpenResetPassword = () => {
    setOpenResetPassword(true);
  };
  const handleCloseResetPassword = () => {
    setOpenResetPassword(false);
  };

  useEffect(async () => {
    if (openFindId || openResetPassword) {
      setId('');
      setEmail('');
      setName('');
      setFindId(null);
    }
  }, [openFindId, openResetPassword]);

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Box sx={{ display: 'flex', flexDirection: 'column', height: '100vh', overflow: 'hidden', bgcolor: '#f8f9fa' }}>
        {/* Header 영역 — Default.js AppBar 스타일 참고 */}
        <AppBar position="static">
          <Toolbar sx={{ pr: '24px' }}>
            <Typography component="h1" variant="h6" color="inherit" noWrap sx={{ flexGrow: 1 }}>
              도화 앱스 (Dohwa Apps)
            </Typography>
          </Toolbar>
        </AppBar>

        {/* Main 영역 */}
        <Container maxWidth={false} sx={{ flexGrow: 1, pb: 4, mt: 4, maxWidth: '1920px', mx: 'auto' }}>
          <Grid container spacing={3}>
            {/* 좌측: PgmList */}
            <Grid item xs={12} md={8} lg={9}>
              <Box sx={{ border: '2px solid #004442', borderRadius: '8px', bgcolor: 'white', height: 'calc(100vh - 120px)', overflowY: 'auto', p: 2 }}>
                <PgmList hideTitle readOnly />
              </Box>
            </Grid>

            {/* 우측: 로그인 + 이용 안내 */}
            <Grid item xs={12} md={4} lg={3}>
              {/* 우측 상단: 로그인 폼 박스 */}
              <Box sx={{ bgcolor: 'white', border: '2px solid #004442', borderRadius: '8px', px: 7, pt: 3, pb: 3 }}>
                <Box sx={{ display: 'flex', justifyContent: 'center', mb: 2 }}>
                  <Box component="img" src={logo} sx={{ width: 160, height: 'auto' }} />
                </Box>
                <Box component="form" onSubmit={handleSubmit(onSubmit)} noValidate>
                  <TextField
                    margin="dense"
                    required
                    fullWidth
                    id="id"
                    label="ID"
                    name="id"
                    autoFocus
                    size="small"
                    InputProps={{ sx: { fontSize: '0.85rem' } }}
                    InputLabelProps={{ sx: { fontSize: '0.85rem' } }}
                    error={!!errors.id}
                    helperText={isSubmitted && errors.id ? errors.id.message : ''}
                    {...register('id', {
                      required: 'ID를 입력해주세요.'
                    })}
                  />
                  <TextField
                    margin="dense"
                    required
                    fullWidth
                    name="password"
                    label="비밀번호"
                    type="password"
                    id="password"
                    size="small"
                    InputProps={{ sx: { fontSize: '0.85rem' } }}
                    InputLabelProps={{ sx: { fontSize: '0.85rem' } }}
                    onKeyPress={handleKeyPress}
                    inputRef={userPwInput}
                    error={!!errors.password}
                    helperText={isSubmitted && errors.password ? errors.password.message : ''}
                    {...register('password', {
                      required: '비밀번호를 입력해주세요.'
                    })}
                  />
                  {error && (
                    <Typography variant="caption" display="block" sx={{ mt: 1, color: 'red' }}>
                      아이디 또는 비밀번호가 잘못 입력 되었습니다.
                      <br />
                      아이디와 비밀번호를 정확히 입력해 주세요.
                    </Typography>
                  )}
                  <Button type="submit" fullWidth variant="contained" size="small" sx={{ mt: 1.5, mb: 0, py: 0.6, fontSize: '0.85rem' }}>
                    로그인
                  </Button>
                  <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', mt: 1 }}>
                    <Link component="button" variant="caption" onClick={handleOpenFindId}>
                      아이디 찾기
                    </Link>
                    <Typography variant="caption" sx={{ mx: 0.5, color: 'text.secondary' }}>
                      |
                    </Typography>
                    <Link component="button" variant="caption" onClick={handleOpenResetPassword}>
                      비밀번호 찾기
                    </Link>
                    <Typography variant="caption" sx={{ mx: 0.5, color: 'text.secondary' }}>
                      |
                    </Typography>
                    <Link component="button" variant="caption" onClick={handleJoin}>
                      회원가입
                    </Link>
                  </Box>
                </Box>
              </Box>

              {/* 평가판 신청 안내 배너 — 2026-04-17까지만 노출 */}
              {isTrialValid && (
                <Box sx={{ bgcolor: 'white', border: '2px solid #004442', borderRadius: '8px', p: 2, mt: 2, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                  <Box>
                    <Typography variant="subtitle1" fontWeight="bold" color="#004442">
                      평가판 신청
                    </Typography>
                    <Typography variant="body2" component="ul" sx={{ pl: 2, m: 0, mt: 0.5, lineHeight: 1.8 }}>
                      <li>신청 마감: 2026. 04. 17 까지</li>
                      <li>사용 기한: 2026. 12. 31 까지</li>
                      <Button
                        variant="contained"
                        size="small"
                        href="https://docs.google.com/forms/d/1-n5PS7VHDRQDJ6YHeFjzs1PAmeI_ndjCLs81-UuuX98/viewform?edit_requested=true"
                        target="_blank"
                        rel="noopener noreferrer"
                        sx={{ mt: 0.5, bgcolor: '#004442', fontSize: '0.75rem', px: 2, py: 0.5, '&:hover': { bgcolor: '#006b68' } }}
                      >
                        평가판 신청하기 →
                      </Button>
                    </Typography>
                  </Box>
                  <Box component="img" src={trialQr} sx={{ width: 120, height: 120, ml: 2, borderRadius: '4px' }} alt="평가판 신청 QR" />
                </Box>
              )}

              {/* 우측 하단: 서비스 이용 안내 + 문의 박스 */}
              <Box sx={{ bgcolor: 'white', border: '2px solid #004442', borderRadius: '8px', p: 3, mt: 2 }}>
                <Typography variant="body2" component="ul" sx={{ pl: 2, m: 0, lineHeight: 1.8 }}>
                  <li>구매된 사용권 1개로 모든 제품 이용</li>
                  <li>6개월/1년 사용권 구매</li>
                  <li>B2B 기반 전자세금계산서 결제</li>
                </Typography>
                <Box sx={{ display: 'flex', gap: 1, mt: 2 }}>
                  <Button fullWidth variant="outlined" size="small" onClick={() => setOpenManual(true)} sx={{ borderColor: '#004442', color: '#004442', '&:hover': { bgcolor: '#004442', color: 'white' } }}>
                    매뉴얼
                  </Button>
                  <Button fullWidth variant="outlined" size="small" onClick={handleOpenQna} sx={{ borderColor: '#004442', color: '#004442', '&:hover': { bgcolor: '#004442', color: 'white' } }}>
                    Q&A 게시판
                  </Button>
                </Box>
                <Box sx={{ borderTop: '1px solid #e0e0e0', mt: 2, pt: 2, textAlign: 'center' }}>
                  <Typography variant="body2" color="text.secondary">
                    문의 :{' '}
                    <Link color="inherit" href="mailto:swmaster@dohwa.co.kr" underline="always" sx={{ fontWeight: 500 }}>
                      swmaster@dohwa.co.kr
                    </Link>
                  </Typography>
                  <Copyright sx={{ mt: 1 }} />
                </Box>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Box>

      <Dialog open={openFindId} onClose={handleCloseFindId}>
        <DialogTitle>ID 찾기</DialogTitle>
        <DialogContent>
          <TextField autoFocus margin="dense" name="name" label="이름" fullWidth value={name} onChange={(e) => setName(e.target.value)} />
          <TextField margin="dense" name="email" label="이메일" type="email" fullWidth value={email} onChange={(e) => setEmail(e.target.value)} />
          {findId && (
            <Typography
              variant="h6"
              align="center"
              sx={{
                mt: 3,
                fontWeight: 'bold',
                color: findId.includes('ID :') ? 'primary.main' : 'error.main'
              }}
            >
              {findId}
            </Typography>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseFindId}>취소</Button>
          <Button
            onClick={() => {
              try {
                axios
                  .post(`/api/user/find`, { name, email })
                  .then((response) => {
                    if (response?.data?.userid) {
                      setFindId(`ID : ${response.data.userid}`);
                    } else {
                      setFindId('일치하는 정보가 없습니다.');
                    }
                  })
                  .catch((err) => {
                    setFindId('일치하는 정보가 없습니다.');
                  });
              } catch (err) {
                alert('ID 찾기 실패!');
              }
            }}
          >
            전송
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog open={openResetPassword} onClose={handleCloseResetPassword}>
        <DialogTitle>비밀번호 초기화</DialogTitle>
        <DialogContent>
          <TextField autoFocus margin="dense" name="id" label="아이디" fullWidth value={id} onChange={(e) => setId(e.target.value)} />
          <TextField autoFocus margin="dense" name="name" label="이름" fullWidth value={name} onChange={(e) => setName(e.target.value)} />
          <TextField margin="dense" name="email" label="이메일" type="email" fullWidth value={email} onChange={(e) => setEmail(e.target.value)} />
          {findId && (
            <Typography
              variant="h6"
              align="center"
              sx={{
                mt: 3,
                fontWeight: 'bold',
                color: findId.includes('비밀번호 초기화') ? 'primary.main' : 'error.main'
              }}
            >
              {findId}
            </Typography>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseResetPassword}>취소</Button>
          <Button
            onClick={() => {
              try {
                axios
                  .post(`/api/user/resetPassword`, { id, name, email })
                  .then((response) => {
                    if (response?.data?.userid) {
                      setFindId(`비밀번호 초기화 링크를 이메일로 발송하였습니다.\n이메일을 받지 못하셨다면 담당자에게 문의해주시기 바랍니다.`);
                    } else {
                      setFindId('일치하는 정보가 없습니다.');
                    }
                  })
                  .catch((err) => {
                    setFindId('일치하는 정보가 없습니다.');
                  });
              } catch (err) {
                alert('일치하는 정보가 없습니다.');
              }
            }}
          >
            전송
          </Button>
        </DialogActions>
      </Dialog>

      {/* Q&A 게시판 모달 (list / detail / register / modify / reply) */}
      <Dialog open={qna.open} onClose={handleCloseQna} maxWidth="lg" fullWidth>
        <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', pb: 0 }}>
          {qna.view === 'list' && 'Q&A 게시판'}
          {qna.view === 'detail' && 'Q&A 상세'}
          {qna.view === 'register' && 'Q&A 글쓰기'}
          {qna.view === 'modify' && 'Q&A 수정'}
          {qna.view === 'reply' && 'Q&A 답글'}
          <Box sx={{ display: 'flex', gap: 1 }}>
            {qna.view !== 'list' && (
              <Button
                size="small"
                sx={{ color: 'text.secondary' }}
                onClick={() => {
                  if (qna.view === 'detail') {
                    setQna({ open: true, view: 'list', viewState: null });
                  } else {
                    // register/modify/reply → detail (register는 list로)
                    if (qna.view === 'register') {
                      setQna({ open: true, view: 'list', viewState: null });
                    } else {
                      setQna({ open: true, view: 'detail', viewState: qna.viewState });
                    }
                  }
                }}
              >
                ← 뒤로
              </Button>
            )}
            <Button onClick={handleCloseQna} size="small" sx={{ color: 'text.secondary' }}>
              ✕ 닫기
            </Button>
          </Box>
        </DialogTitle>
        <DialogContent sx={{ p: 1 }}>
          {qna.view === 'list' && (
            <BoardList
              name="Q&A"
              kind="qna"
              file={true}
              columns={qnaColumns}
              onRowClick={(s) => setQna({ open: true, view: 'detail', viewState: s })}
              onCreateClick={(s) => setQna({ open: true, view: 'register', viewState: s })}
              hideTitle
            />
          )}
          {qna.view === 'detail' && (
            <BoardDetail
              modalState={qna.viewState}
              onBack={() => setQna({ open: true, view: 'list', viewState: null })}
              onModify={(s) => setQna({ open: true, view: 'modify', viewState: s })}
              onReply={(s) => setQna({ open: true, view: 'reply', viewState: s })}
              hideTitle
            />
          )}
          {(qna.view === 'register' || qna.view === 'modify' || qna.view === 'reply') && (
            <BoardRegister
              state={qna.view === 'register' ? 'register' : qna.view === 'modify' ? 'modify' : 'reply'}
              modalState={qna.viewState}
              onBack={() => {
                if (qna.view === 'register') setQna({ open: true, view: 'list', viewState: null });
                else setQna({ open: true, view: 'detail', viewState: qna.viewState });
              }}
              onSuccess={() => setQna({ open: true, view: 'list', viewState: null })}
              hideTitle
            />
          )}
        </DialogContent>
      </Dialog>

      {/* 매뉴얼 PDF 모달 */}
      <Dialog open={openManual} onClose={() => setOpenManual(false)} maxWidth="lg" fullWidth>
        <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          도화 앱스 사용 매뉴얼
          <Button onClick={() => setOpenManual(false)} size="small" sx={{ color: 'text.secondary' }}>
            ✕ 닫기
          </Button>
        </DialogTitle>
        <DialogContent sx={{ p: 0, height: '80vh', overflow: 'hidden' }}>
          <iframe src={manualPdf} width="100%" height="100%" style={{ border: 'none', display: 'block' }} title="매뉴얼" />
        </DialogContent>
      </Dialog>
    </ThemeProvider>
  );
}
